export default __webpack_public_path__ + "static/d07-a03869ea3f718e177954753093c39c88.png";